var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4226 3.57737C16.0972 3.25193 15.5695 3.25193 15.2441 3.57737L8.33333 10.4881L8.33333 11.6666H9.51184L16.4226 4.75588C16.748 4.43045 16.748 3.90281 16.4226 3.57737ZM14.0656 2.39886C15.0419 1.42255 16.6248 1.42255 17.6011 2.39886C18.5774 3.37517 18.5774 4.95808 17.6011 5.93439L10.4463 13.0892C10.29 13.2455 10.078 13.3333 9.85702 13.3333H7.5C7.03976 13.3333 6.66667 12.9602 6.66667 12.5L6.66667 10.1429C6.66667 9.92192 6.75446 9.70996 6.91075 9.55368L14.0656 2.39886ZM5 4.99996C4.53976 4.99996 4.16667 5.37306 4.16667 5.8333V15C4.16667 15.4602 4.53976 15.8333 5 15.8333H14.1667C14.6269 15.8333 15 15.4602 15 15V10.8333C15 10.3731 15.3731 9.99996 15.8333 9.99996C16.2936 9.99996 16.6667 10.3731 16.6667 10.8333V15C16.6667 16.3807 15.5474 17.5 14.1667 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5.8333C2.5 4.45258 3.61929 3.3333 5 3.3333H9.16667C9.6269 3.3333 10 3.70639 10 4.16663C10 4.62687 9.6269 4.99996 9.16667 4.99996H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAlt);
export default __webpack_public_path__ + "static/media/pencil-alt.ced243ee796c50cfab4d77e9964af160.svg";
export { ForwardRef as ReactComponent };